module.exports = __webpack_public_path__ + "img/banner-document.7d480605.png";